<template>
  <base-sheet :visible="visible" aria-label="Avaliar conteúdo" @close="$emit('cancel')">
    <h3 class="vxl-sheet__title">O que você achou desse conteúdo?</h3>
    <p class="vxl-sheet__subtitle legend">{{ subtitle }}</p>

    <div class="stars" role="radiogroup" aria-label="Nota de 1 a 5 estrelas">
      <button
        v-for="i in 5"
        :key="i"
        type="button"
        class="star-btn"
        role="radio"
        :aria-checked="selected === i"
        :aria-label="i === 1 ? '1 estrela' : i + ' estrelas'"
        :style="i <= selected ? { color: $theme.primaryColor } : null"
        @click="selected = i"
      >
        <i :class="i <= selected ? 'fa fa-star' : 'fa fa-star-o'" aria-hidden="true"></i>
      </button>
    </div>

    <button
      type="button"
      class="vxl-sheet__action vxl-sheet__action--primary"
      :disabled="!selected || selected === initialValue"
      :style="{ background: $theme.primaryColor }"
      @click="$emit('select', selected)"
    >
      {{ confirmLabel }}
    </button>
    <button type="button" class="vxl-sheet__action vxl-sheet__action--ghost" @click="$emit('cancel')">
      Fechar
    </button>
  </base-sheet>
</template>

<script>
import BaseSheet from '@/components/base/BaseSheet';

// Avaliação da aula. Inline, cada estrela é um alvo de ~20px colado no vizinho —
// no toque erra a nota, e o clique já grava. Aqui o alvo é 44px e a nota só sai
// no confirmar, então dá pra corrigir antes.
export default {
  name: 'RatingSheet',
  components: { BaseSheet },
  props: {
    visible: { type: Boolean, default: false },
    // Nota já registrada (0 = ainda não avaliou).
    initialValue: { type: Number, default: 0 }
  },
  data () {
    return { selected: this.initialValue || 0 };
  },
  computed: {
    subtitle () {
      const labels = {
        1: 'Não gostei',
        2: 'Poderia ser melhor',
        3: 'Bom',
        4: 'Muito bom',
        5: 'Excelente'
      };
      return labels[this.selected] || 'Toque nas estrelas para dar sua nota.';
    },
    confirmLabel () {
      // Reabrir pra trocar a nota é o caso comum — o rótulo precisa deixar claro
      // que substitui a anterior.
      return this.initialValue ? 'Atualizar avaliação' : 'Avaliar';
    }
  },
  watch: {
    visible (now) {
      // Re-sincroniza na reabertura: o pai pode ter recebido nota nova.
      if (now) this.selected = this.initialValue || 0;
    }
  }
};
</script>

<style scoped lang="scss">
// Altura reservada: o texto muda com a nota e sem isto a sheet pula.
.legend {
  min-height: 19px;
  margin-bottom: 8px;
}

.stars {
  display: flex;
  justify-content: center;
  gap: 4px;
  margin: 4px 0 20px;
}

.star-btn {
  // 44px = alvo mínimo de toque recomendado (iOS HIG / Material).
  width: 44px;
  height: 44px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  font-size: 28px;
  line-height: 1;
  color: var(--md-border-strong, rgba(255, 255, 255, 0.3));
  transition: transform 0.12s ease, color 0.12s ease;

  &:active {
    transform: scale(0.88);
  }
}
</style>
